/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx, Text } from 'theme-ui'
import { useResponsiveValue } from '@theme-ui/match-media'

import Section from './../Section/index'
import Button from './../../atoms/Button'
import NumberItem from './../../molecules/NumberItem'
import { YourWindowGlobalProps } from './types'
import GlobalBadges from './../../organisms/GlobalBadges'

import {
  SectionContainerStyled,
  SectionMediaStyled,
  SectionContentStyled,
  SectionNumberListStyled,
  SectionDescStyled,
  SectionBtnStyled,
  SectionNumberListItemStyled
} from './styles'

const YourWindowGlobalSection: React.FC<YourWindowGlobalProps> = ({
  id,
  heading,
  isHeadingGreen,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,
  data
}) => {
  const isTablet = useResponsiveValue([false, false, true, true], {
    defaultIndex: 0
  })

  const { numbers, desc, button, backgroundImage, iconList } = data

  const numbersContainer = (
    <SectionNumberListStyled>
      {numbers &&
        numbers.map(({ key, number, caption }) => (
          <SectionNumberListItemStyled {...{ key }}>
            <NumberItem {...{ number, caption }} />
          </SectionNumberListItemStyled>
        ))}
    </SectionNumberListStyled>
  )

  return (
    <Section
      {...{ id, inner, paddingTop, paddingBottom, headingPadding, bgColor, heading, isHeadingGreen, subheading, description, data }}
      body={
        <SectionContainerStyled>
          {!isTablet && numbers ? numbersContainer : ''}
          <SectionMediaStyled>
            <GlobalBadges {...{ backgroundImage, iconList }} />
          </SectionMediaStyled>

          <SectionContentStyled>
            {isTablet && numbers ? numbersContainer : ''}
            {desc && (
              <SectionDescStyled>
                <Text variant="bodyMontserrat6">{desc}</Text>
              </SectionDescStyled>
            )}
            {button && (
              <SectionBtnStyled>
                <Button variant="withArrow" {...button} />
              </SectionBtnStyled>
            )}
          </SectionContentStyled>
        </SectionContainerStyled>
      }
    />
  )
}

export default YourWindowGlobalSection
